import { makeStyles, styled } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'

export const SelectRound = styled(TextField)(({ theme, embedview }) => ({
  marginBottom: theme.spacing(5),
  marginTop: theme.spacing(2),
  width: '300px',
  background: '#fff',
  '& label.Mui-focused': {
    color: embedview ? theme.palette.ryderCup.neutral : theme.palette.primary.main,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: embedview ? theme.palette.ryderCup.neutral : 'rgba(131, 111, 80, 0.5)',
      borderRadius: embedview ? theme.spacing(1) : '0px',
    },
    '&.Mui-focused fieldset': {
      borderColor: embedview ? 'rgba(0, 0, 0, 0.87)' : theme.palette.primary.main,
    },
  },
}))

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.grey[100],
    color: theme.palette.secondary.main,
  },
  container: ({ isEmbedView }) => ({
    marginBottom: isEmbedView ? '110px' : 'unset',
    [theme.breakpoints.down('sm')]: {
      marginBottom: isEmbedView ? '80px' : 'unset',
    },
  }),
}))

export default useStyles
